import { CheckSquare, Mail, Sliders } from 'lucide-react';
import { createLeadFormField, generateFieldId, type LeadFormField } from '../../../lib/crm/leadForms';

type Props = {
  onAddField: (field: LeadFormField) => void;
  compact?: boolean;
};

const shell = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", system-ui, sans-serif',
};

function PaletteItem({
  icon: Icon,
  title,
  subtitle,
  onClick,
}: {
  icon: typeof Mail;
  title: string;
  subtitle: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full p-3 bg-white border border-gray-200/60 rounded-[10px] text-left active:bg-gray-50 active:border-gray-300 transition-all duration-150 active:scale-[0.98] shadow-[0_1px_2px_rgba(0,0,0,0.05)] touch-manipulation"
      style={{ WebkitTapHighlightColor: 'transparent', ...shell }}
    >
      <div className="flex items-center gap-2">
        <Icon className="w-4 h-4 text-gray-500 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-[14px] font-semibold text-gray-900" style={{ letterSpacing: '-0.01em' }}>
            {title}
          </p>
          <p className="text-[12px] text-gray-500" style={{ letterSpacing: '-0.01em' }}>
            {subtitle}
          </p>
        </div>
      </div>
    </button>
  );
}

export default function LeadFormFieldLibrary({ onAddField, compact }: Props) {
  return (
    <div className={compact ? 'space-y-4' : 'space-y-5'} style={shell}>
      {!compact && (
        <h5 className="text-[14px] font-semibold text-gray-900" style={{ letterSpacing: '-0.01em' }}>
          Field library
        </h5>
      )}

      <div>
        <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-[0.04em] mb-2">
          Customer
        </p>
        <PaletteItem
          icon={Mail}
          title="Customer Info"
          subtitle="Name, email, phone — creates customer"
          onClick={() => onAddField(createLeadFormField('customer_info', 'Customer Information'))}
        />
      </div>

      <div>
        <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-[0.04em] mb-2">
          Basic fields
        </p>
        <div className="space-y-2">
          <PaletteItem
            icon={CheckSquare}
            title="Checkbox"
            subtitle="Multiple choice options"
            onClick={() =>
              onAddField(
                createLeadFormField('checkbox', 'Select Options', false, [
                  { id: generateFieldId('option_1'), label: 'Option 1' },
                  { id: generateFieldId('option_2'), label: 'Option 2' },
                ]),
              )
            }
          />
          <PaletteItem
            icon={Sliders}
            title="Custom Field"
            subtitle="Text, email, phone, and more"
            onClick={() => onAddField(createLeadFormField('text', 'Custom Field', true))}
          />
        </div>
      </div>
    </div>
  );
}
